// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3w_bG","log":"ModalInventoryLogs_log__3yZbD","date":"ModalInventoryLogs_date__2woIF","userName":"ModalInventoryLogs_userName__3_Ls6"};